<div>
  <mat-card-title mat-dialog-title class="d-flex align-items-center mb-0">
    <mat-icon class="mr-2">{{ data.icon || 'description' }}</mat-icon>
    {{ data.title }}
  </mat-card-title>
  <mat-card-subtitle
    class="popup-subtitle"
    style="margin-bottom: 8px !important"
    >{{ data.subtitle }}</mat-card-subtitle
  >
</div>
<mat-divider style="margin: 0px 24px"></mat-divider>
<mat-divider style="margin: 0px 24px"></mat-divider>
<mat-dialog-content class="mt-3">
  <app-drag-and-drop
    style="width: 100%"
    [allowUpload]="true"
    [allowDelete]="false"
    [uploadDirectly]="false"
    [displayImg]="true"
    (triggerFileSelected)="triggerFileSelected($event)"
    [showUploadedFiles]="false"
    [allowedTypesNames]="data.allowedTypesNames"
    [allowedTypesRegex]="data.allowedTypesRegex"
    [maxSize]="data.maxSize"
    [remainingFilesCount]="100"
    [remainingFiles]="false"
    required
  >
  </app-drag-and-drop>
</mat-dialog-content>
<mat-dialog-actions
  class="d-flex justify-content-end"
  style="padding: 16px 24px"
>
  <button
    mat-flat-button
    color="primary"
    (click)="onClose()"
    [matTooltip]="'shared.document-uploader.cancel-tooltip' | translate"
  >
    {{ 'shared.document-uploader.cancel' | translate }}
  </button>
</mat-dialog-actions>
